import { IFile } from '@sdk/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sdk } from '@/services';

const FileService = sdk.getService('FileService');

export const useMutateFiles = () => {
  const qc = useQueryClient();

  const uploadFileMutation = useMutation<IFile, Error, Partial<IFile>>({
    mutationFn: (file: Partial<IFile>) => FileService.createUploadSignedUrl(file),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['files'] })
  });

  const deleteFileMutation = useMutation<unknown, Error, string>({
    mutationFn: (fileId: string) => FileService.removeFile(fileId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['files'] })
  });

  return {
    uploadFile: uploadFileMutation.mutateAsync,
    deleteFile: deleteFileMutation.mutateAsync,
    isPending: uploadFileMutation.isPending || deleteFileMutation.isPending
  };
};
